import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {formatDate} from "@angular/common";
import {BookingsApiService} from "../../api/bookings-api.service";
import {
  BookingAppointmentDto,
  BookingDayListDto,
  BookingDayTimeListDto, BookingSlotDto,
  BookingTimePeriodDto
} from "../../types/bookings.types";
import {LocaleSettings} from "primeng/calendar";
import {PrimeNGConfig} from "primeng/api";
import {AppMessageService} from "../../../../core/service/app-message.service";
import {MessageHelper} from "../../../../core/helper/message-helper";


@Component({
  selector: 'app-schedule-appointment',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['schedule-appointment.component.scss']
})
export class ScheduleAppointmentComponent extends CoreComponent implements OnInit {

  @Input() scheduleTypeId!: number;
  @Input() appointmentTypeId: number | undefined;
  @Output() onSelectPeriod: EventEmitter<BookingSlotDto | null> = new EventEmitter<BookingSlotDto | null>();


  bookingDayList?: BookingDayListDto;

  timeSlots?: BookingSlotDto[];

  freeDays: Date[] = [];

  // selectedPeriod?: BookingTimePeriodDto | null;
  selectedPeriod?: BookingSlotDto | null;

  selectedDate: Date = new Date();
  today: Date = new Date();

  germanConfig = {
    firstDayOfWeek: 1, // Monday
    dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    today: 'Heute',
    clear: 'Klar'
  };

  constructor(
    protected bookingsApi: BookingsApiService,
    private primengConfig: PrimeNGConfig,
    protected messageService: AppMessageService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.primengConfig.setTranslation(this.germanConfig);

    this.refreshComponent();
  }


  refreshComponent() {
    // fetch free days for current month
    this.fetchBookingDaysForMonth(this.selectedDate);

  }

  handleSelectDate(event: Date) {
    if (!this.appointmentTypeId) {
      return;
    }
    this.busy = true;
    this.timeSlots = undefined;
    this.bookingsApi.getFreeSlots(this.appointmentTypeId, event).subscribe(value => {
      this.timeSlots = value;
      // if (this.timeSlots.periods) {
      //   this.timeSlots.periods.sort((a, b) => a.id.localeCompare(a.id));
      // }

      this.busy = false;
    }, error => {
      // this.messageService.showErrorMessage("","Die freien Termine konnten nicht ermittelt werden.");
      MessageHelper.showErrorMessage("Die freien Termine konnten nicht ermittelt werden.", this.messageService)
    });
  }

  handleMonthChange(event: any) {
    let monthDate = new Date(event.year, event.month - 1, 1);
    this.fetchBookingDaysForMonth(monthDate);
  }

  fetchBookingDaysForMonth(date: Date) {

    this.busy = true;
    let start = new Date(date.getFullYear(), date.getMonth(), 1);
    let end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const startDate = formatDate(start, 'yyyy-MM-dd', 'en-US');
    const endDate = formatDate(end, 'yyyy-MM-dd', 'en-US');

    this.bookingDayList = undefined;
    this.freeDays = [];

    this.changeSelectPeriod(null);
    
    if (this.appointmentTypeId) {
      this.bookingsApi.getFreeDays(this.appointmentTypeId, start, end).subscribe(response => {
        this.bookingDayList = response;
        this.freeDays = response.localDates.map((day: string) => new Date(day));
        this.busy = false;
        this.initialized = true;
      }, error => {
        // this.messageService.showErrorMessage("","Die freien Zeiten für diesen Tag konnten nicht ermittelt werden.");
        MessageHelper.showErrorMessage("Die freien Zeiten für diesen Tag konnten nicht ermittelt werden.", this.messageService)
      });
    }

  }

  schedule() {
    /*
    if (this.selectedPeriod) {
    this.bookingsApi.schedule(this.appointmentTypeScheduleTypeId, this.selectedPeriod.id).subscribe(value => {
      this.onAppointmentScheduled.emit(value);
    });
    } else {
      alert('please select time slot')
    }
     */

  }


  isDayFree(day: { day: number, otherMonth: boolean }): boolean {

    if (day.otherMonth) {
      return false;
    }

    return this.freeDays.some(freeDay =>
      freeDay.getDate() === day.day);
  }

  changeSelectPeriod(period: BookingSlotDto | null) {
    this.selectedPeriod = period;
    this.onSelectPeriod.emit(this.selectedPeriod);
  }

  onSelect(period: BookingSlotDto) {
    this.changeSelectPeriod(period);
  }

}
